import LayoutPrimary from '../../layouts/Primary';
import Settings from '@/views/Admin/Config/Settings/Settings';
import DashboardSettings from '@/views/Admin/Config/Settings/Dashboard';
import EmailSettings from '@/views/Admin/Config/Settings/Email';
import Navigation from '@/views/Admin/Config/Settings/Navigation';
import SiteCompletion from '@/views/Admin/Config/Settings/SiteCompletion';
import Profession from '@/views/Admin/Config/Settings/Profession';
import TopNavigation from '@/views/Admin/Config/Settings/TopNavigation';

export default [
    {
        path: '/settings',
        name: 'Settings',
        component: Settings,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
        children: [
            {
                path: '/settings/site-completion',
                name: 'SiteCompletion',
                component: SiteCompletion,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary,
                },
            },

            {
                path: '/settings/coach-specialty',
                name: 'Profession',
                component: Profession,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary,
                },
            },

            {
                path: '/settings/dashboard',
                name: 'DashboardSettings',
                component: DashboardSettings,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary,
                },
            },

            {
                path: '/settings/email',
                name: 'EmailSettings',
                component: EmailSettings,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary,
                },
            },

            {
                path: '/settings/navigation',
                name: 'NavigationSettings',
                component: Navigation,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary,
                },
            },

            {
                path: '/settings/top-navigation',
                name: 'TopNavigation',
                component: TopNavigation,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary,
                },
            },
        ]
    },
];
